import { isNoindexTestHost } from '~/lib/site-host';

export default defineNuxtPlugin(() => {
  const requestUrl = useRequestURL();
  const host = process.client ? window.location.hostname : requestUrl.hostname;

  if (!isNoindexTestHost(host)) return;

  useHead({
    meta: [
      { key: 'robots', name: 'robots', content: 'noindex, nofollow' },
      { key: 'googlebot', name: 'googlebot', content: 'noindex, nofollow' },
    ],
  });
});
